/**
 * Task type enum and static configuration.
 * Replaces the legacy schedule-configs query with static values.
 */
export var TaskType;
(function (TaskType) {
    TaskType[TaskType["General"] = 0] = "General";
    TaskType[TaskType["Thinning"] = 1] = "Thinning";
    TaskType[TaskType["Weeding"] = 2] = "Weeding";
    TaskType[TaskType["Fleecing"] = 3] = "Fleecing";
    TaskType[TaskType["BedShaping"] = 4] = "BedShaping";
    TaskType[TaskType["Planting"] = 5] = "Planting";
    TaskType[TaskType["Transplanting"] = 6] = "Transplanting";
    TaskType[TaskType["Irrigation"] = 7] = "Irrigation";
    TaskType[TaskType["SoilSample"] = 8] = "SoilSample";
    TaskType[TaskType["Chemical"] = 9] = "Chemical";
})(TaskType || (TaskType = {}));
export const TaskTypeConfigs = {
    [TaskType.General]: {
        name: "task.type.general",
        color: "#8f8f8f",
        contrastColor: "white",
        allowMultipleDays: true,
        oneDatePerPlanting: false,
        editPermission: "edit_general_tasks",
        isIrrigationBlockType: false,
    },
    [TaskType.Thinning]: {
        name: "task.type.thinning",
        color: "#44bb99",
        contrastColor: "white",
        allowMultipleDays: false,
        oneDatePerPlanting: true,
        editPermission: "set_thinning_schedules",
        isIrrigationBlockType: false,
    },
    [TaskType.Weeding]: {
        name: "task.type.weeding",
        color: "#78abdd",
        contrastColor: "white",
        allowMultipleDays: false,
        oneDatePerPlanting: true,
        editPermission: "set_weeding_schedules",
        isIrrigationBlockType: false,
    },
    [TaskType.Fleecing]: {
        name: "task.type.fleecing",
        color: "#ee8968",
        contrastColor: "white",
        allowMultipleDays: false,
        oneDatePerPlanting: true,
        editPermission: "set_fleecing_schedules",
        isIrrigationBlockType: false,
    },
    [TaskType.BedShaping]: {
        name: "task.type.bed-shaping",
        color: "#5987a6",
        contrastColor: "white",
        allowMultipleDays: false,
        oneDatePerPlanting: true,
        linkedType: TaskType.Transplanting,
        linkedOffset: 3,
        editPermission: "set_planting_schedules",
        isIrrigationBlockType: false,
    },
    [TaskType.Planting]: {
        name: "task.type.planting",
        color: "#ffd966",
        contrastColor: "black",
        allowMultipleDays: false,
        oneDatePerPlanting: true,
        editPermission: "set_planting_schedules",
        isIrrigationBlockType: false,
    },
    [TaskType.Transplanting]: {
        name: "task.type.transplanting",
        color: "#70ae47",
        contrastColor: "white",
        allowMultipleDays: false,
        oneDatePerPlanting: true,
        linkedType: TaskType.BedShaping,
        linkedOffset: -3,
        editPermission: "set_planting_schedules",
        isIrrigationBlockType: false,
    },
    [TaskType.Irrigation]: {
        name: "task.type.irrigation",
        color: "#1994e6",
        contrastColor: "white",
        allowMultipleDays: false,
        oneDatePerPlanting: false,
        editPermission: "set_irrigation_schedules",
        isIrrigationBlockType: true,
    },
    [TaskType.SoilSample]: {
        name: "task.type.soil-sample",
        color: "#70665c",
        contrastColor: "white",
        allowMultipleDays: false,
        oneDatePerPlanting: false,
        editPermission: "edit_soil_sample_schedules",
        isIrrigationBlockType: true,
    },
    [TaskType.Chemical]: {
        name: "task.type.chemical",
        color: "#9966cc",
        contrastColor: "white",
        allowMultipleDays: false,
        oneDatePerPlanting: false,
        editPermission: "edit_chemical_schedules",
        isIrrigationBlockType: false,
    },
};
/**
 * Check if user can edit a task type based on their permissions.
 */
export function canEditTaskType(taskType, userPermissions) {
    if (!userPermissions)
        return false;
    const permSet = userPermissions instanceof Set
        ? userPermissions
        : new Set(userPermissions);
    return permSet.has(TaskTypeConfigs[taskType].editPermission);
}
